import {useGLTF} from "@react-three/drei";
import { useSafeGLTF } from "../../../utils/safeGLTFLoader";
import {GroupProps} from "@react-three/fiber";
import {Color, DoubleSide, Mesh} from "three";
import {memo} from "react";

interface PropsType extends GroupProps {
    model: string;
    color: Color | undefined
}

export const Beam = memo((props: PropsType) => {
    const {nodes, materials} = useSafeGLTF(props.model);
    const material = materials["material_main"];
    material.color = props.color;
    material.roughness = 0.5;
    material.metalness = 0.5;
    material.side = DoubleSide;
    return (
        <group {...props}>
            {Object.keys(nodes)?.map((object, index) => {
                if (nodes[object] instanceof Mesh) return <mesh castShadow receiveShadow key={index} geometry={nodes[object].geometry} material={material}/>
            })}
        </group>
    );
})
